import clsx from "clsx";
import { useEffect, useState } from "react";

const defaultStates = [
  {
    icon: <i className="ki-filled ki-check text-white"></i>,
    value: "yes",
    className: "bg-brand border-bg-brand",
  },
  {
    icon: <i className="ki-filled ki-minus text-white"></i>,
    value: "partial",
    className: "bg-warning border-warning",
  },
  {
    icon: <i className="ki-filled ki-cross text-white"></i>,
    value: "no",
    className: "bg-[#8D4F61] border-[#8D4F61]",
  },
];

export type MultiStateValue = string | number | null;

export interface MultiStateCheckboxProps {
  states?: {
    icon: React.ReactNode;
    value: MultiStateValue;
    className?: React.HTMLAttributes<HTMLButtonElement>["className"];
  }[];
  onChange?: (value: MultiStateValue) => void;
  value?: MultiStateValue;
}

export function MultiStateCheckbox({
  states = defaultStates,
  onChange,
  value,
}: MultiStateCheckboxProps) {
  const [activeState, setActiveState] = useState<MultiStateValue>(null);
  const statesWithEmpty = [
    { icon: undefined, value: null, className: "border-gray-400" },
    ...states,
  ];
  const activeStateIndex = statesWithEmpty.findIndex(
    (state) => state.value === activeState,
  );

  useEffect(() => {
    setActiveState(value ?? null);
  }, [value]);

  return (
    <div className="h-6 flex space-x-1">
      <button
        type="button"
        className={clsx(
          "w-6 h-6 rounded-md border-[1px]",
          statesWithEmpty[activeStateIndex]?.className,
        )}
        onClick={() => {
          const nextIndex = (activeStateIndex + 1) % statesWithEmpty.length;
          if (value === undefined)
            setActiveState(statesWithEmpty[nextIndex].value);
          onChange?.(statesWithEmpty[nextIndex].value);
        }}
      >
        {statesWithEmpty[activeStateIndex]?.icon}
      </button>
    </div>
  );
}
